import PropTypes from 'prop-types';

import ToggleBase from './ToggleBase';

import './styles/toggleButtonStyles.css';

const ToggleButton = ({ children, ...props }) => (
  <ToggleBase
    className="toggle-button bg-gray-2 text-gray-6 inline-block rounded overflow-hidden"
    {...props}
  >
    {children}
  </ToggleBase>
);

ToggleButton.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
};

export default ToggleButton;
